import React, { useState } from 'react';
import Theme from '../theme';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { View, StyleSheet, Text } from 'react-native';
import { getNextStep, navigateToNextStep } from './actions';
import { defaultScale } from '../utils/scaling';
import { SignupScreen } from 'fitbeat.gym-core';
import { Button } from '../components';
import {isDateOlderThan16 } from '../utils/validator';
import DatePicker from 'react-native-date-picker';
import { GoogleAnalytics } from '../services/google-analytics';


const HomeDateOfBirth = ({
  t,
  navigation,
  getNextStep,
  navigateToNextStep,
}) => {
  const [date, setDate] = useState(null);
  const setDateOfBirthAndNavigateToNextStep = () => {
    const  googleAnalytics = new GoogleAnalytics();
    getNextStep({
      currentScreen: SignupScreen.DateOfBirth,
      userProfile: {dateOfBirth: date },
    });
    navigateToNextStep(navigation);
    googleAnalytics.logEventWithParamaters('sign_up_date_of_birth', {dateOfBirth: date });

  };
  return (
    <View style={styles.container}>
      <View>
        <Text
          style={[Theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
        >
          {t('whatIsYourDateOfBirth')}
        </Text>
        <Text
          style={[
            Theme.textStyle.bodyCopyReg,
            { color: Theme.GREY_MEDIUM},
          ]}
        >
          {t('personalizeFitnessJourneyDateOfBirth')}
        </Text>
        <View style={{ alignItems: 'center', paddingVertical: defaultScale(10) }}>
          <DatePicker
          date={date || new Date(2000, 0, 1)}
          onDateChange={setDate}
          mode='date'
          androidVariant='nativeAndroid'
          />
          {!!isDateOlderThan16(date) && date && <Text style={styles.errorText}>{t('mustBe16')}</Text>}
        </View>
      </View>
      <Button
        title={t('next')}
        disabled={!date || !!isDateOlderThan16(date)}
        fontColor={Theme.WHITE}
        containerStyle={{ marginTop: 3 }}
        onPress={setDateOfBirthAndNavigateToNextStep}
        overrideFontStyles={[
          Theme.textStyle.bodyCopyBold,
          { color: Theme.WHITE },
        ]}
        containerStyle={{ height: defaultScale(45), marginBottom: defaultScale(30),}}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: defaultScale(16),
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-between',
  },
  bookingSelectionTitle: {
    fontSize: Theme.textStyle.heading.fontSize,
    fontFamily: Theme.textStyle.heading.fontFamily,
    textAlign: 'center',
  },
  errorText: {
    color: 'red',
    marginBottom: defaultScale(5),
  },
});

const mapStateToProps = (state) => {
  return {
    userProfile: state.auth.signup.userProfile,
  };
};

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export const HomeDateOfBirthScreen = translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(HomeDateOfBirth),
);
